<template>
        <el-dialog
                :visible.sync="dialogVisible"
                width="60%"
                top="60px"
                :fullscreen="dialogFull"
                :close-on-click-modal="false"
                :destroy-on-close="true"
                :before-close="handleClose"
                append-to-body
                :modal-append-to-body="false"
        >
        <template slot="title">
                <div class="avue-crud__dialog__header">
                        <span class="el-dialog__title">
                            车牌变更
                        </span>
                        <i class="el-icon-full-screen" style="margin-right:20px;position:relative;top:-1px"  @click="dialogFull=!dialogFull"></i>

                </div>
        </template>
        <div style="max-height:calc(100vh - 320px);overflow-y:scroll;overflow-x:hidden;">

                <avue-form
                        :option="option"
                        v-model="form"
                        ref="form"
                        @submit="formSubmit"
                        @reset-change="resetForm"
                >

                </avue-form>

        </div>
        <template slot="footer">
                <el-button @click="formSubmit1" size="small" type="primary"><span class="el-icon-check"></span> 保存</el-button>
                <el-button @click="handleClose" size="small" style="margin-right:15px"><span class="el-icon-close" ></span> 取消</el-button>
        </template>
        </el-dialog>
</template>
<script>
import {
    carNoChange
  } from '@/api/v4ward/park/vehicle/parkvehicle';
export default {
        data(){
                return{
                        form:{},
                        dialogFull:false,
                        dialogVisible:false,
                        option:{
                                submitBtn:false,
                                emptyBtn:false,
                                column:[
                                        {
                                                label: '车场名称',
                                                prop: '$parkingLotId',
                                                type: 'select',
                                                span:8,
                                                disabled:true,
                                                props: {
                                                        label: 'title',
                                                        value: 'id',

                                                },

                                        },
                                        {
                                                label: '车牌号',
                                                prop: 'plateNumber',
                                                disabled:true,
                                                width: 100,
                                                span:8,

                                        },
                                        {
                                                label: '车辆类型',
                                                prop: '$vehicleType',
                                                type: 'select',
                                                width: 80,
                                                span:8,
                                                disabled:true,
                                                dataType: 'number',
                                                dicUrl: 'api/blade-system/dict/dictionary?code=vehicle_type',
                                                props: { label: 'dictValue', value: 'dictKey' },

                                        },
                                        {
                                                label: '车主姓名',
                                                prop: 'driverName',
                                                span:8,
                                                disabled:true,


                                        },
                                        {
                                                label: '手机号码',
                                                prop: 'mobile',
                                                span:8,
                                                disabled:true,

                                        },
                                        {
                                                label: '余额',
                                                prop: 'balance',
                                                span: 8,
                                                disabled:true,

                                        },
                                        {
                                                label: '新车牌号',
                                                prop: 'newCarNo',
                                                width: 100,
                                                span:8,
                                                rules: [
                                                        {
                                                                required: true,
                                                                message: '请输入车牌',
                                                                trigger: 'blur',
                                                        },
                                                        {
                                                                required: true,
                                                                pattern: this.$validation.carPlate,
                                                                message: '车牌格式不对',
                                                                trigger: 'change',
                                                        },
                                                ],
                                        },
                                        {
                                                label: '说明',
                                                prop: 'changeRemark',
                                                width: 100,
                                                span:16,
                                                maxlength:150,
                                                showWordLimit:true,
                                        },
                                ]
                        }
                }
        },
        methods:{
                openDialog(data){
                        this.form = data;
                        this.dialogVisible = true;
                },
                formSubmit1(){
                        this.$refs.form.submit();
                        // this.$emit('onLoad')
                },
                formSubmit(row,done){
                        let form = {
                                id:row.id,
                                newCarNo:row.newCarNo,
                                changeRemark:row.changeRemark
                        }
                        carNoChange(form).then(res=>{
                                this.$message.success('操作成功!');
                                done();
                                this.dialogVisible = false;
                                this.$emit('onLoad')
                        }).catch(error=>{
                                done();
                        })
                },
                resetForm(){

                },
                handleClose(done){
                        let self = this;
                        this.$confirm('确认关闭?', '提示', {
                                confirmButtonText: '确定',
                                cancelButtonText: '取消',
                                type: 'warning',
                        })
                        .then(()=> {
                                self.dialogVisible = false;

                        })
                        .catch(()=> {

                        });
                },
        }
}
</script>
